var Apidae_Layout = (function(){
    var self = {};
    var grid = $('.SimpleLayout .grid');

    self.gridIsotope = undefined;
    self.gridScrollBar = undefined;

    self.infiniteScroll = function(){
        //if(loadData === false){
            loadData = true;
            var href = $('.paginationAjax a').attr('href');
            $('.paginationAjax').remove();

            if(!!href) {
                Apidae_Util.ajaxSend('.spinnerPaginate');
                $.get(href, function (data) {
                    var jqObj = jQuery(data);
                    var items = $(jqObj.find(".grid .grid__item"));
                    var newPaginationAjax = $(jqObj.find(".paginationAjax"));

                    $('.paginate').append(newPaginationAjax);

                    imagesLoaded(items, function () {
                        self.gridIsotope.append(items).isotope('appended', items);
                        self.loadSlider();
                        self.gridIsotope.isotope();

                        $(".pinned").pin({
                            containerSelector: ".main-content-simple",
                            minWidth: 940
                        });

                        $(window).scrollTop($(window).scrollTop()+1);
                        Apidae_Util.ajaxComplete('.spinnerPaginate');

                        // self.gridScrollBar.mCustomScrollbar("scrollTo","-=250");
                    });
                });
                setTimeout(
                    function()
                    {
                        loadData = false;
                        Apidae_Util.ajaxComplete('.spinnerPaginate');
                    }, 1000);
            }
        //}
    };

    self.loadSlider = function(){
        $('.sliders').bxSlider({
            slideWidth:0,
            minSlides:1,
            maxSlides:1,
            moveSlides:1,
            slideMargin:0,
            pager: false,
            auto: false,
            adaptiveHeight: true,
            captions: false
        });
    };

    self.init = function(){

        self.loadSlider();

        var masonryMode = grid.data("masonry-mode");

        // init Isotope
        self.gridIsotope = grid.isotope({
            itemSelector: '.grid__item',
            layoutMode: masonryMode,
            transitionDuration: '0',
            masonry: {},
            fitRows: {
                rowHeight: 420
            },
            vertical: {
                rowHeight: 120
            }
        });

        //Wrapper grid Custom Scrollbar
        // self.gridScrollBar = gridWrap.mCustomScrollbar({
        //     live: "on",
        //     scrollInertia: 350,
        //     theme:"dark-thin",
        //     mouseWheel:{ preventDefault: true },
        //     callbacks:{
        //         onTotalScrollOffset:350,
        //         onTotalScroll:function(){ infiniteScroll(); }
        //     }
        // });

        Apidae_Layout.Events.init();
    };

    return self;
})();

Apidae_Layout.Events = (function(){
    var self = {};
    var theGrid = $('#theGrid');
    var gridWrap = $('.SimpleLayout .grid__wrapper');
    var grid = $('.SimpleLayout .grid');
    var mapContainer = $('#mapContainer');

    self.init = function(){

        // change masonry mode
        $('.masonry-mode-button-group').on( 'click', 'button', function() {
            var masonryModeValue = $(this).data('masonry-mode');
            grid.attr('data-masonry-mode', masonryModeValue);
            Apidae_Layout.gridIsotope.isotope({ layoutMode: masonryModeValue });
            //Apidae_Layout.gridScrollBar.mCustomScrollbar("scrollTo","top");
        });

        function gridLayout() {
            Apidae_Layout.gridIsotope.isotope('layout');
            $(".pinned").pin({
                containerSelector: ".main-content-simple",
                minWidth: 600
            });
            mapContainer.css({width: mapContainer.parent().outerWidth() - 20});
            Apidae_Map.resize();
        }

        // change layout mode
        $('.layout-mode-button-group').on( 'click', 'button', function() {
            var layoutModeValue = $(this).data('layout-mode');
            theGrid.removeClass().addClass(layoutModeValue);
            setTimeout(gridLayout, 300);
        });

        // change is-checked class on buttons
        $('.button-group').each( function( i, buttonGroup ) {
            var $buttonGroup = $( buttonGroup );
            $buttonGroup.on( 'click', 'button', function() {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $(this).addClass('is-checked');
            });
        });


        // infinite scroll
        $(window).scroll(function(){

            if($('.paginationAjax').length){
                var loadData = false;
                var scrollTop = $(window).scrollTop();
                var browserHeight = $(window).height();
                var offset = $('.paginationAjax').offset();

                if(offset!==null && (offset.top - browserHeight - 644 <= scrollTop) && (loadData === false) ){
                    // console.log(offset.top - browserHeight);
                    // console.log(scrollTop);
                    Apidae_Layout.infiniteScroll();
                }
            }
        });
    };

    return self;
})();

$(window).load(function(){
    Apidae_Layout.init();
});